// The underway item names the ACTIVITY being run, e.g. "Sending Email".
// Activity labels default to "{Kind} - {StageName}" (see EmailFormEditor,
// ReviewForm, etc.), so drop the stage suffix to leave the activity's own name.
// A custom label with no such suffix is shown unchanged.

// Most automatable actions are "send"-style (email, review request,
// assessment invite, survey), so the default verb is "Send". Interviews are
// scheduled, not sent — hence "Schedule interview" (matches the design).
const VERB_BY_KIND: Record<string, string> = {
  interview: 'Schedule',
};

export const verbForKind = (kind: string | undefined): string =>
  (kind && VERB_BY_KIND[kind]) || 'Send';

// "Email - Application Review" + "Application Review" → "Email".
// "Welcome email" + <any stage> → "Welcome email".
export const stripStageSuffix = (
  label: string,
  stageName: string | undefined
): string => {
  const suffix = stageName ? ` - ${stageName}` : '';
  return suffix && label.endsWith(suffix)
    ? label.slice(0, -suffix.length)
    : label;
};

// "email" + "Email - Application Review" + "Application Review" → "Send Email".
export const getActivityActionLabel = (
  kind: string | undefined,
  label: string,
  stageName: string | undefined
): string => `${verbForKind(kind)} ${stripStageSuffix(label, stageName)}`;
